<div class="props-container">
    @if (selectionModel?.selected?.length == 0) {
        <mat-toolbar>
            <div>
                <mat-icon>info</mat-icon>
                <mat-label>{{'general.noItemSelected' | transloco}}</mat-label>
            </div>
        </mat-toolbar>
    }
    @if (accountInitialCopyResources !== PREVIOUSLY_USED_ACCOUNT) {
        <div style="width: 260px; text-align: center; position: relative; left: 20px">
            <app-loading [size]="'50px'" [style]="{'margin-top': '150px'}"></app-loading>
            <br />
            <div>
                <span style="font-size: 1em; text-align: center">{{'general.pleaseWaitInitAccount' | transloco}}</span>
                <br />
                <span>{{'general.likeTherty' | transloco}}</span>
                <br />
                <br />
                <mat-icon style="position: relative; left: -5px; top: 6px">watch_later</mat-icon>
                <span style="font-size: 1.4em; text-align: center">{{'general.downloaded' | transloco}} :
                    {{accountInitialCopyResources}}</span>
                <br>
                <hr />
                <br />
                <app-video-link style="display: inline-block;" videoLink="overview"></app-video-link>
                <br />
                <br />
                <br />
            </div>
        </div>
    }
    @if (accountInitialCopyResources === PREVIOUSLY_USED_ACCOUNT) {
        <div [ngClass]="{'loading': loading}">
            <small class="debug">{{me}}</small>
            <hr />
            @if (selectionModel?.selected.length === 1) {
                <div>
                    @if (!minimized) {
                        <div>
                            <mat-form-field style="width: 225px;">
                                <mat-label>{{'placeholder.category' | transloco}}</mat-label>
                                <input inputrestriction="basic1" matInput placeholder="" value="{{selectedResource?.tree_path}}"
                                    readonly>
                            </mat-form-field>
                            <a mat-icon-button (click)="openCategoryTree()">
                                <mat-icon>folder_open</mat-icon>
                            </a>
                        </div>
                    }
                    <!-- <div class="mat-form-field">
                    <app-category-filter [selectedCategory]="selectedResource?.tree_path" [categories]="categories" (updateCategory)="updateResourceProperty($event);"></app-category-filter>
                    </div> -->
                    @if (!minimized) {
                        <mat-form-field>
                            <mat-label>{{'placeholder.resourceName' | transloco}}</mat-label>
                            <input inputrestriction="basic1" #resourceName matInput (keyup)="updateResourceProperty()"
                                placeholder="" value="{{selectedResource?.resource_name}}">
                        </mat-form-field>
                    }
                    @if (minimized) {
                        <mat-form-field>
                            <mat-label>{{'placeholder.resourceName' | transloco}}</mat-label>
                            <input readonly matInput placeholder="" value="{{selectedResource?.resource_name}}">
                        </mat-form-field>
                    }
                    @if (!minimized) {
                        <mat-form-field>
                            <mat-label>{{'general.accessKey' | transloco}}</mat-label>
                            <mat-select #resourceAccessKey (selectionChange)="updateResourceProperty()"
                                value="{{selectedResource?.access_key}}">
                                @for (item of accessMask; track item) {
                                <mat-option [value]="item">{{item}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                    <hr />
                    @if (!minimized) {
                        <ul>
                            <li>type: {{selectedResource?.resource_type?.toUpperCase()}}</li>
                            <li>height: {{selectedResource?.resource_pixel_width?.toUpperCase()}}</li>
                            <li>width: {{selectedResource?.resource_pixel_height?.toUpperCase()}}</li>
                            <li>modified: {{selectedResource?.resource_date_modified | StringJSV2Pipe:stringJSPipeArgs}}</li>
                            <li>created: {{selectedResource?.resource_date_created | StringJSV2Pipe:stringJSPipeArgs}}</li>
                            <li>bytes: {{selectedResource?.resource_bytes_total}}</li>
                            <li>id: {{selectedResource?.resource_id}}</li>
                            @if (selectedResource?.resource_type?.toUpperCase() === 'MP4') {
                                <li>duration: {{selectedResource?.resource_total_time | StringJSV2Pipe:stringJSPipeArgsRound}} seconds
                                </li>
                            }
                        </ul>
                    }
                </div>
            }
            @if (selectedResources) {
                <mat-list>
                    <div mat-subheader fxFlex>
                        <span style="margin-bottom: auto; margin-top: auto;">Selected Resources:</span>
                        @if (selectionModel?.selected?.length > 0) {
                            <a mat-icon-button (click)="onDeselect()" matTooltip="{{'general.deselectAll' | transloco}}">
                                <mat-icon>deselect</mat-icon>
                            </a>
                        }
                    </div>
                    @for (item of selectedResources; track item; let ind = $index) {
                        <mat-list-item>
                            <mat-icon matListItemIcon>image</mat-icon>
                            <div matListItemTitle>{{item.resource_name}}.{{item.resource_type}}</div>
                            <div matListItemLine>{{item.resource_date_modified | date}}</div>
                            <mat-icon matListItemIcon class="close-icon" (click)="toggleSelection(item.resource_id)">close</mat-icon>
                        </mat-list-item>
                        <hr />
                    }
                </mat-list>
            }
            @if (selectionModel?.selected.length === 1) {
                <div>
                    <div>
                        @switch (m_resourceType) {
                            @case ('image') {
                                <div>
                                    <img class="mat-card-image" [src]="m_imagePath" />
                                </div>
                            }
                            @case ('svg') {
                                <div>
                                    <app-svg-icon style="padding-left: 25px" [height]="'300'" [width]="'240'"
                                        [path]="m_svgPath"></app-svg-icon>
                                </div>
                            }
                            @case ('video') {
                                <div>
                                    <vg-player (onPlayerReady)="onPlayerReady($event)">
                                        <vg-controls>
                                            <vg-play-pause></vg-play-pause>
                                            <vg-playback-button></vg-playback-button>
                                            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                                            <vg-scrub-bar>
                                                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                                <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                                            </vg-scrub-bar>
                                            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                                            <vg-mute></vg-mute>
                                            <vg-volume></vg-volume>
                                            <vg-fullscreen></vg-fullscreen>
                                        </vg-controls>
                                        <video id="singleVideo" [vgMedia]="$any(media)" #media [autoplay]="false" preload="auto">
                                            <source src="{{m_playResource}}" type="video/mp4">
                                        </video>
                                    </vg-player>
                                </div>
                            }
                            @case ('flash') {
                                <div>
                                    <p style="padding-left: 20px">Flash swf content</p>
                                    <fa-icon class="largeIcon" [icon]="faBolt"></fa-icon>
                                </div>
                            }
                            @case ('flash_video') {
                                <div>
                                    <mat-icon class="largeIcon">missed_video_call</mat-icon>
                                    <br />
                                    <hr />
                                    <mat-label style="padding: 20px">preview not available</mat-label>
                                    <br />
                                    <mat-label style="padding: 20px">consider using mp4 file format</mat-label>
                                    <hr />
                                    <!-- <app-video-player [options]="{ autoplay: true, controls: true, sources: [{ src: './assets/videos/test.mp4', type: 'video/mp4' }]}"></app-video-player> -->
                                </div>
                            }
                        }
                    </div>
                </div>
                <div fxFlex fxLayoutAlign="start center">
                    <a mat-icon-button [disabled]="selectionModel?.selected?.length !== 1 ||
                        (
                            selectedResource?.resource_type !== 'jpg'
                            && selectedResource?.resource_type !== 'jpeg'
                            && selectedResource?.resource_type !== 'gif'
                            && selectedResource?.resource_type !== 'svg'
                            && selectedResource?.resource_type !== 'png'
                        )"
                    (click)="onEditResource()" style="opacity: 0.7;" matTooltip="{{'general.editWithPaintBrush' | transloco}}" class="hide-xs">
                        <mat-icon>palette</mat-icon>
                    </a>
                    <!-- <a mat-icon-button (click)="onDelete()" matTooltip="{{'scenes.delete' | transloco}}">
                        <mat-icon>delete</mat-icon>
                    </a> -->
                    <a mat-icon-button (click)="showFullScreenImage()" matTooltip="{{'general.fullScreen' | transloco}}">
                        <mat-icon>fullscreen</mat-icon>
                    </a>
                </div>
            }
        </div>
    }

    @if (loading) {
        <div style="position:absolute; top: 0; left: 0; width: 100%;">
            <app-loading [type]="7" [size]="'40px'" [style]="{'margin-top': '100px'}"></app-loading>
        </div>
    }
</div>


<!--        <mat-toolbar *ngIf="showToolbar" color="primary">-->
<!--            <button matTooltip="{{'general.deselectAll' | transloco}}" (click)="deselectItems()" mat-icon-button-->
<!--                    [disabled]="selectionModel.selected.length == 0">-->
<!--                <mat-icon>indeterminate_check_box</mat-icon>-->
<!--            </button>-->
<!--            <button matTooltip="{{'general.editResource' | transloco}}"-->
<!--                    [disabled]="selectionModel.selected.length !== 1"-->
<!--                    mat-icon-button (click)="onEditResource()">-->
<!--                <mat-icon>palette</mat-icon>-->
<!--            </button>-->
<!--            <button *ngIf="accessConfig?.del !== false" matTooltip="{{'general.deleteForever' | transloco}}" (click)="onDelete()"-->
<!--                    [ngStyle]="{'color': selectionModel.selected.length > 1 ? 'red' : null}"-->
<!--                    [disabled]="selectionModel.selected.length == 0"-->
<!--                    mat-icon-button>-->
<!--                <mat-icon>delete</mat-icon>-->
<!--            </button>-->
<!--            <span [ngStyle]="{'opacity': selectionModel.selected.length === 0 ? 0.5 : 1}" style="padding-left: 8px; padding-bottom: 8px;" class="fill-remaining-space">-->
<!--        <mat-icon style="position: relative; top: 7px">dns</mat-icon>-->
<!--                {{'general.selected' | transloco}}: {{selectionModel.selected.length}}-->
<!--      </span>-->
<!--        </mat-toolbar>-->
<!--        <mat-toolbar *ngIf="showToolbar" color="primary">-->
<!--                    <span class="fill-remaining-space">-->
<!--                        <mat-icon style="position: relative; top: 7px">dns</mat-icon>-->
<!--                        total resources selected: {{selectionModel.selected.length}}-->
<!--                        <br/>-->
<!--                    </span>-->
<!--        </mat-toolbar>-->
<!--        <div *ngIf="selectionModel?.selected.length > 0 && !previewMode">-->
<!--            <a mat-button style="color: red" (click)="onDelete()" [disabled]="accessConfig.del === false">-->
<!--                <mat-icon matTooltip="{{'general.removeResources' | transloco}}">delete</mat-icon>-->
<!--            </a>-->
<!--        </div>-->
